import syiActions from './syi-actions';
import {
    fetchForCategory,
    fetchCategoryAttributeSuggestions
} from './attributes-actions';

import campaignCodeActions from './campaign-code-actions';
import { getSyiSlice } from 'tradera/apps/syi/state/selectors/syi';

import { webApiClient } from 'tradera/utils/http';
import { selectPreferredLanguage } from 'tradera/state/language/selectors';
import shippingActions from './shipping-actions';
import priceActions from './price-actions';

export const updateCategoryRestrictions =
    (categoryId) => async (dispatch, getState) => {
        if (!categoryId) {
            return;
        }

        const { languageCodeIso2 } = selectPreferredLanguage(getState());
        const { data } = await webApiClient.get(
            `/selling/category-restriction/${categoryId}?locale=${languageCodeIso2}`
        );
        dispatch(syiActions.setCategoryRestriction(data));
    };

const reset = () => (dispatch) => {
    dispatch({
        type: 'RESET_CATEGORY'
    });
};

const setDraftCategory = (categoryId, categoryPath) => (dispatch, getState) => {
    var slice = getSyiSlice(getState());
    dispatch({
        type: 'SET_DRAFT_CATEGORY',
        categoryId: categoryId,
        categoryPath: categoryPath
    });
    dispatch(campaignCodeActions.validateCampaignCode());
    dispatch(updateCategoryRestrictions(categoryId));
    dispatch(fetchForCategory(categoryId));
    dispatch(
        fetchCategoryAttributeSuggestions(
            categoryId,
            slice.shortDescription.shortDescription
        )
    );
    dispatch(shippingActions.setShippingRecommendations(categoryId));
    if (categoryPath?.length > 0) {
        dispatch(
            priceActions.rootCategoryHasBeenSelected(categoryPath[0].categoryId)
        );
    }
};

export default {
    setDraftCategory,
    reset
};
